import React from 'react';
import "./CSS/Reason.css"

const Reason = ({src, header, p}) => {
    return (
        <div className='reason-item' style={{border: '2px solid black'}}>
            <img src={src} alt="" width={'40px'} height={'40px'}/>
            <h3 className='inner-header-text'>{header}</h3>
            <p className='description-text'>{p}</p>
        </div>
    )
};

export default Reason;
